<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Giphy" class="d-icon d-icon--giphy" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2.667h8v10.666H4V2.667Z" fill="currentColor"/><path d="M2 2h2v12H2V2Z" fill="#04FF8E"/><path d="M12 5.333h2V14h-2V5.333Z" fill="#8E2EFF"/><path d="M2 13.333h12v2H2v-2Z" fill="#00C5FF"/><path d="M2 .667h6.667v2H2v-2Z" fill="#FFF152"/><path d="M12.223 4.222V2.445h-1.779V.667H8.667V6H14V4.222" fill="#FF5B5B"/><path d="M12 7.333V6h2" fill="#551C99"/><path fill-rule="evenodd" clip-rule="evenodd" d="M8.667.667v2H7.333" fill="#999131"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconGiphy',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
